/**
 * @since 1.7.0
 */
import { Index } from '..';
import { atRecord } from '../At/Record';
/**
 * @category constructor
 * @since 1.7.0
 */
export function indexRecord() {
    return Index.fromAt(atRecord());
}
